import React from 'react'

import Info from '../Info'

import useStyles from './styles'

type HeaderWidgetProps = {
  title: string
  information?: string
  children: React.ReactNode
}

const HeaderWidget: React.FC<HeaderWidgetProps> = ({
  title,
  information,
  children
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Info text={information} className={classes.info} />

      <div className={classes.title}>{title}</div>

      <div className={classes.children}>{children}</div>
    </div>
  )
}

export default HeaderWidget
